import { type I18nLocale, t } from '@ardoq/i18n';

export const getTodayOption = (i18nLocale: I18nLocale) => ({
  value: 'now+0d',
  label: t(i18nLocale, 'dateTime:today', 'Today'),
});

export const getTomorrowOption = (i18nLocale: I18nLocale) => ({
  value: 'now+1d',
  label: t(i18nLocale, 'dateTime:tomorrow', 'Tomorrow'),
});

export const getYesterdayOption = (i18nLocale: I18nLocale) => ({
  value: 'now-1d',
  label: t(i18nLocale, 'dateTime:yesterday', 'Yesterday'),
});

export const TODAY_VALUE = 'now+0d';
export const TOMORROW_VALUE = 'now+1d';
export const YESTERDAY_VALUE = 'now-1d';
